import { render, staticRenderFns } from "./FormularioDatos.vue?vue&type=template&id=468a0c5c"
import script from "./FormularioDatos.vue?vue&type=script&lang=js"
export * from "./FormularioDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports